import { useState, useRef } from 'react';

// Video Section Component
const VideoSection = () => {
    const videoRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };

    return (
        <div
            className="video-section"
            style={{
                padding: '20px 0',
                background: '#f8f8f8'
            }}
        >
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                    <h2 style={{
                        fontSize: '2.5rem',
                        color: '#4f047a',
                        marginBottom: '20px'
                    }}>
                        Experience Our Vision
                    </h2>
                    <p style={{
                        fontSize: '1.1rem',
                        color: '#666',
                        maxWidth: '600px',
                        margin: '0 auto'
                    }}>
                        Hover over the video to see our architectural journey come to life
                    </p>
                </div>

                <div
                    className="video-wrapper"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    style={{
                        position: 'relative',
                        maxWidth: '900px',
                        margin: '0 auto',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease',
                        transform: isHovered ? 'scale(1.02)' : 'scale(1)'
                    }}
                >
                    <video
                        ref={videoRef}
                        muted
                        loop
                        playsInline
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: 'block'
                        }}
                    >
                        {/* Using a sample video from a public source - replace with your own */}
                        <source
                            src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>

                    {/* Play icon overlay when not hovering */}
                    {!isHovered && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '80px',
                                height: '80px',
                                borderRadius: '50%',
                                background: 'rgba(79, 4, 122, 0.8)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <div
                                style={{
                                    width: 0,
                                    height: 0,
                                    borderLeft: '25px solid white',
                                    borderTop: '15px solid transparent',
                                    borderBottom: '15px solid transparent',
                                    marginLeft: '5px'
                                }}
                            />
                        </div>
                    )}

                    {/* Hover instruction text */}
                    {/*<div*/}
                    {/*    style={{*/}
                    {/*        position: 'absolute',*/}
                    {/*        bottom: '20px',*/}
                    {/*        left: '50%',*/}
                    {/*        transform: 'translateX(-50%)',*/}
                    {/*        background: 'rgba(0,0,0,0.7)',*/}
                    {/*        color: 'white',*/}
                    {/*        padding: '10px 20px',*/}
                    {/*        borderRadius: '5px',*/}
                    {/*        fontSize: '0.9rem',*/}
                    {/*        opacity: isHovered ? 0 : 1,*/}
                    {/*        transition: 'opacity 0.3s ease'*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Hover to play*/}
                    {/*</div>*/}
                </div>

                {/* Optional: Add video description or call-to-action */}
                <div style={{
                    textAlign: 'center',
                    marginTop: '40px',
                    padding: '0 20px'
                }}>
                    <p style={{
                        color: '#666',
                        fontSize: '1rem',
                        marginBottom: '20px'
                    }}>
                        Discover how we transform architectural visions into reality
                    </p>
                    {/*<a*/}
                    {/*    href="/architectural-work"*/}
                    {/*    style={{*/}
                    {/*        display: 'inline-block',*/}
                    {/*        padding: '12px 30px',*/}
                    {/*        background: '#a2bf0d',*/}
                    {/*        color: 'white',*/}
                    {/*        textDecoration: 'none',*/}
                    {/*        borderRadius: '5px',*/}
                    {/*        transition: 'background 0.3s ease'*/}
                    {/*    }}*/}
                    {/*    onMouseOver={(e) => e.target.style.background = '#4f047a'}*/}
                    {/*    onMouseOut={(e) => e.target.style.background = '#a2bf0d'}*/}
                    {/*>*/}
                    {/*    View Our Portfolio*/}
                    {/*</a>*/}
                </div>
            </div>
        </div>
    );
};

export default VideoSection;